import { useEffect, useRef, useState } from 'react';
import { TermsContent } from '../../pages/TermsAndCondition';
import { SIP_END } from '../campaign';

const Chev = ({ size = 18 }) => (
  <span className="gfg-chev">
    <svg viewBox="0 0 24 24" style={{ width: size, height: size }}><path d="M6 9l6 6 6-6" /></svg>
  </span>
);

const FAQS = [
  {
    q: 'What is GoSats Go For Gold Campaign?',
    a: 'Our Go For Gold campaign, running <b>14th–31st August</b>, with two offers: the Gold Streak (14th–26th August) and 5% back in SuperCoins on gold purchases.',
  },
  {
    q: 'What is the Gold streak?',
    a: 'If you complete seven Gold SIPs during your streak window, you will receive <b>2% of everything you invested back</b> as bonus sats or gold. You can opt in from the campaign page in the app.',
    streak: true,
  },
  {
    q: 'When does my streak start and how long do I have?',
    a: "Your streak starts with your first Gold SIP - that day counts as Day 1. You must make your first SIP between <b>14 and 16 August</b>. You'll need to complete 7 SIPs before your window closes, and your remaining days are shown on the campaign page.",
    streak: true,
  },
  {
    q: 'Can I make more than one SIP in a day?',
    a: 'You can, but only one counts per day towards your streak. Days run to midnight IST.',
    streak: true,
  },
  {
    q: 'Is there a minimum or maximum SIP amount?',
    a: 'No. You can invest any amount you are comfortable with. Since your reward is 2% of the total you invest, it scales with you either way.',
    streak: true,
  },
  {
    q: 'What if I miss a day?',
    a: 'You get <b>one skip</b>. Miss one day and your streak survives - your window is 8 days for 7 SIPs, so you have a spare. Miss a second day and your streak ends.',
    streak: true,
  },
  {
    q: 'Can I restart my streak if it breaks?',
    a: 'No. One streak per user for this campaign.',
    streak: true,
  },
  {
    q: 'When do I receive my streak reward?',
    a: 'As soon as your seventh SIP goes through, a claim button will appear in the app. You will have <b>48 hours</b> to tap it and collect your reward.',
    streak: true,
  },
  {
    q: 'Can I earn both Sats and Gold as a reward during the campaign?',
    a: 'No. Whatever reward preference you have selected on Day 1 of your streak is what your Streak Bonus will pay out in for the entire streak. Any preference changes you make mid-streak will not apply to your active bonus.',
    streak: true,
  },
  {
    q: 'What happens if I do not claim in time?',
    a: 'The reward is forfeited once the 48 hours are up. We will send you reminders before it expires, but the window itself cannot be extended.',
    streak: true,
  },
  {
    q: 'What if one of my SIPs fails or gets refunded?',
    a: 'Only successful, settled SIPs count towards your streak. If a SIP is reversed after your reward has been credited, we may adjust or reverse the reward accordingly.',
    streak: true,
  },
  {
    q: 'What is the gold offer?',
    a: 'On any gold purchase of <b>₹200 or more</b>, you get <b>5% of the value back in SuperCoins</b>.',
  },
  {
    q: 'When will my SuperCoins be credited?',
    a: 'Within 24 hours of a successful purchase.',
  }
];

/* animated collapse helper — mirrors the height 0 ↔ scrollHeight transitions */
function useCollapse(open, settleMs) {
  const ref = useRef(null);
  const first = useRef(true);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    if (first.current) {
      first.current = false;
      el.style.height = open ? 'auto' : '0px';
      return undefined;
    }
    let timer;
    if (open) {
      el.style.height = el.scrollHeight + 'px';
      timer = setTimeout(() => { el.style.height = 'auto'; }, settleMs);
    } else {
      el.style.height = el.scrollHeight + 'px';
      requestAnimationFrame(() => { el.style.height = '0px'; });
    }
    return () => clearTimeout(timer);
  }, [open, settleMs]);
  return ref;
}

function FaqItem({ q, a, open, onToggle }) {
  const bodyRef = useCollapse(open, 400);
  return (
    <div className={'gfg-faq-item' + (open ? ' gfg-open' : '')}>
      <button className="gfg-faq-q" onClick={onToggle}>
        <span>{q}</span>
        <Chev />
      </button>
      <div className="gfg-faq-a" ref={bodyRef}>
        <p dangerouslySetInnerHTML={{ __html: a }} />
      </div>
    </div>
  );
}

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState(-1);
  const [tncOpen, setTncOpen] = useState(false);
  const tncRef = useCollapse(tncOpen, 440);

  const sipOver = Date.now() > SIP_END.getTime();
  const visibleFaqs = sipOver ? FAQS.filter((f) => !f.streak) : FAQS;

  return (
    <section className="gfg-faq">
      <h2 className="gfg-sec-title gfg-rv">Good to know</h2>
      <p className="gfg-sec-sub gfg-rv">Everything about the streak, the rewards<br />and the fine print.</p>

      <div className="gfg-faq-list gfg-rv">
        {visibleFaqs.map((f, i) => (
          <FaqItem
            key={f.q}
            q={f.q}
            a={f.a}
            open={openIdx === i}
            onToggle={() => setOpenIdx(openIdx === i ? -1 : i)}
          />
        ))}
      </div>

      <div className={'gfg-tnc gfg-rv' + (tncOpen ? ' gfg-open' : '')}>
        <button className="gfg-tnc-head" onClick={() => setTncOpen(!tncOpen)}>
          <span>Terms &amp; conditions</span>
          <Chev size={16} />
        </button>
        <div className="gfg-tnc-body" ref={tncRef}>
          <div className="gfg-tnc-full">
            <TermsContent />
          </div>
        </div>
      </div>

    </section>
  );
}
